/**
 * Persists an unauthenticated draft message so it can be
 * restored after signup/login.
 */

const DRAFT_KEY = 'sayitnow_try_draft';

export interface TryDraft {
  recipientName: string;
  message: string;
  photoDataUrl?: string; // base64 data URL for small preview
  photoFile?: never; // File objects can't be serialised
}

export function saveTryDraft(draft: TryDraft) {
  try {
    localStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
  } catch {
    // quota exceeded — silently ignore
  }
}

export function getTryDraft(): TryDraft | null {
  try {
    const raw = localStorage.getItem(DRAFT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearTryDraft() {
  localStorage.removeItem(DRAFT_KEY);
}
